module.exports = "https://web-assets.ifttt.com/packs/media/icons/icon-unchecked-20c5c007.svg";